import GetMatchedBannerExperienceA from './getMatchedBannerExperienceA';

export default GetMatchedBannerExperienceA;
